import React from 'react';
import {
    HeadingWrapCont,
    HeadingElements,
    Line,
    SocialCont,
    Social,
} from './styles';
import { Container } from '../container';
import { HeadingMain } from '../../styles/';

function HeadingWrap() {
    return (
        <Container>
            <HeadingWrapCont>
                <HeadingElements>
                    <Line />
                    <SocialCont>
                        <a
                            title='Instagram - Dansky3D'
                            target='_blank'
                            rel='noreferrer'
                            href='https://www.instagram.com/dansky3d/'
                        >
                            <Social>
                                <svg
                                    className='insta'
                                    width='30'
                                    height='28'
                                    viewBox='0 0 30 28'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z'
                                        fill='#fff'
                                    />
                                </svg>
                            </Social>
                        </a>

                        <a
                            title='Twitter - Dansky3D'
                            target='_blank'
                            rel='noreferrer'
                            href='https://twitter.com/dansky3d'
                        >
                            <Social>
                                <svg
                                    className='twitter'
                                    width='30'
                                    height='28'
                                    viewBox='0 0 30 28'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M8.07969 18.0619C8.07969 17.5998 7.74199 17.1732 7.20879 17.0844C7.29766 16.5512 7.77754 16.018 8.07969 15.8047L7.42207 15.1648C6.65781 15.8225 6.05352 16.7467 6.05352 17.9908C6.05352 18.6484 6.51563 19.075 7.10215 19.075C7.65313 19.075 8.07969 18.6129 8.07969 18.0619ZM10.7102 18.0619C10.7102 17.5998 10.3725 17.1732 9.83926 17.0844C9.92813 16.5512 10.408 16.018 10.7102 15.8047L10.0525 15.1648C9.28828 15.8225 8.68398 16.7467 8.68398 17.9908C8.68398 18.6484 9.14609 19.075 9.73262 19.075C10.2836 19.075 10.7102 18.6129 10.7102 18.0619Z'
                                        fill='#fff'
                                        fill-opacity='0.03'
                                    />
                                    <path
                                        d='M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z'
                                        fill='#fff'
                                    />
                                </svg>
                            </Social>
                        </a>


                        <a
                            title='LynkFire - Dansky3D'
                            target='_blank'
                            rel='noreferrer'
                            href='https://opensea.io/Dansky3d'
                        >
                            <Social>
                            <svg className='lynkfire' width="30" height="28" viewBox="0 0 533 800" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path class="fil0" d="M267 0l-267 0 0 133c0,74 60,134 133,134l72 0 10 0c28,0 51,23 52,51l0 215 0 134c0,73 60,133 133,133l133 0 0 -267 0 -266 0 -134c0,-73 -60,-133 -133,-133l-133 0z"/>
   <path class="fil0" d="M0 348l138 0c29,0 52,23 52,52l0 52 -138 0c-29,0 -52,-23 -52,-52l0 -52z"/>
</svg>

                            </Social>
                        </a>
                        <a
                            title='Gumroad - Dansky3D'
                            target='_blank'
                            rel='noreferrer'
                            href='https://dansky3d.gumroad.com/'
                        >
                            <Social>
                            <svg className='gumroad' width="30" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="white"/>
                            <path d="M14.6108 24.0635C9.92396 24.0635 7.16699 20.3043 7.16699 15.6282C7.16699 10.7688 10.1997 6.82617 15.9893 6.82617C21.9627 6.82617 23.9845 10.8604 24.0764 13.1526H19.7572C19.6653 11.869 18.5625 9.94356 15.8974 9.94356C13.0485 9.94356 11.2105 12.4191 11.2105 15.4448C11.2105 18.4705 13.0485 20.9461 15.8974 20.9461C18.4706 20.9461 19.5734 18.929 20.0329 16.9118H15.8974V15.2615H24.575V23.6968H20.768V18.3789C20.4923 20.3043 19.2977 24.0635 14.6108 24.0635Z" fill="#131313"/>
                        </svg>
                            </Social>
                        </a>
                    </SocialCont>
                </HeadingElements>
                <HeadingMain>
                    <span>
                        Hi there, I’m Daniel. <br />
                    </span>
                    <span>
                        Graphic Designer and <span className='blue'>3D Artist</span>{' '}
                        <br />
                    </span>
                    <span></span>
                </HeadingMain>
            </HeadingWrapCont>
        </Container>
    );
}

export default HeadingWrap;
